module.exports = __webpack_public_path__ + "static/Psycho-Active-Logo-Hat-Web-transparent-f297890a13447ef57fcb66ec68fea931.png";